import { ColorScheme } from 'services/theme.service';

export enum TimeFormat {
  _12h = '12h',
  _24h = '24h'
}

export class UserSettings {
  constructor(
    public language: string,
    public timeFormat: TimeFormat,
    public colorScheme: ColorScheme
  ) {}
}
